export const BOARD_DECK = {
  id: 'demo-skl-board-deck',
  title: 'Board deck from metrics',
  description: 'Builds a short board update deck from the Finance sheet and HubSpot, with a chart and a takeaway per slide.',
  apps: ['Google Sheets', 'HubSpot'],
  usedCount: 3,
  lastUsedMinutesAgo: 32 * 24 * 60,
  instructions: `**Build the board update for the period given (default: last month):**

1. Read bookings, ARR, burn, and runway from the Finance sheet's Summary tab.
2. Read pipeline coverage, win rate, and average cycle length from HubSpot.
3. Make one slide per theme: Headline, Revenue, Pipeline, Customers, Spend, Asks.
4. Each slide gets one chart and one sentence that says what changed and why.
5. Compare with the previous period and call out anything that moved more than 10%.

**Output:** a .pptx file plus a five-bullet summary in the chat.`,
  examples: ['Build the September board update', 'Make a Q3 board deck'],
}
